export const PLAN_ASSESSED = 'PLAN_ASSESSED'
export const STATS_UNLOADED = 'STATS_UNLOADED'